package io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.Icons

public val Icons.AndroidSimpleIcons: ImageVector
    get() {
        if (_androidSimpleIcons != null) {
            return _androidSimpleIcons!!
        }
        _androidSimpleIcons = Builder(name = "AndroidSimpleIcons", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(18.44f, 5.56f)
                curveToRelative(-0.68f, 1.17f, -1.35f, 2.33f, -2.03f, 3.50f)
                curveToRelative(-0.04f, -0.02f, -0.07f, -0.03f, -0.11f, -0.04f)
                curveToRelative(-1.83f, -0.70f, -3.48f, -0.8f, -4.42f, -0.79f)
                curveToRelative(-1.86f, 0.02f, -3.35f, 0.46f, -4.26f, 0.82f)
                curveToRelative(-0.08f, -0.15f, -1.75f, -3.02f, -2.02f, -3.49f)
                arcToRelative(1.15f, 1.15f, 0.0f, false, false, -0.14f, -0.19f)
                curveToRelative(-0.33f, -0.36f, -0.91f, -0.49f, -1.38f, -0.20f)
                curveToRelative(-0.48f, 0.28f, -0.71f, 0.94f, -0.39f, 1.50f)
                curveToRelative(1.95f, 3.37f, -0.10f, -0.22f, 1.95f, 3.36f)
                curveToRelative(0.02f, 0.03f, -0.50f, 0.26f, -1.39f, 1.02f)
                curveTo(2.90f, 12.18f, 0.45f, 14.77f, 0.0f, 18.99f)
                horizontalLineToRelative(24.0f)
                curveToRelative(-0.12f, -1.11f, -0.37f, -2.10f, -0.75f, -3.07f)
                curveToRelative(-0.74f, -1.91f, -1.84f, -3.29f, -2.74f, -4.18f)
                arcToRelative(12.11f, 12.11f, 0.0f, false, false, -2.13f, -1.69f)
                curveToRelative(0.66f, -1.12f, 1.31f, -2.26f, 1.97f, -3.39f)
                curveToRelative(0.21f, -0.36f, 0.19f, -0.80f, -0.01f, -1.12f)
                arcToRelative(1.1f, 1.1f, 0.0f, false, false, -0.85f, -0.53f)
                curveToRelative(-0.52f, -0.05f, -0.94f, 0.31f, -1.05f, 0.55f)
                close()
                moveTo(18.4f, 14.02f)
                curveToRelative(0.39f, 0.59f, 0.32f, 1.33f, -0.16f, 1.65f)
                curveToRelative(-0.48f, 0.32f, -1.19f, 0.10f, -1.58f, -0.49f)
                curveToRelative(-0.39f, -0.59f, -0.32f, -1.33f, 0.16f, -1.65f)
                curveToRelative(0.47f, -0.32f, 1.18f, -0.11f, 1.58f, 0.49f)
                close()
                moveTo(7.21f, 13.53f)
                curveToRelative(0.48f, 0.32f, 0.55f, 1.06f, 0.16f, 1.65f)
                curveToRelative(-0.39f, 0.59f, -1.10f, 0.81f, -1.58f, 0.49f)
                curveToRelative(-0.48f, -0.32f, -0.55f, -1.06f, -0.16f, -1.65f)
                curveToRelative(0.40f, -0.60f, 1.11f, -0.81f, 1.58f, -0.49f)
                close()
            }
        }
        .build()
        return _androidSimpleIcons!!
    }

private var _androidSimpleIcons: ImageVector? = null
